<template>
  <main class="payment-page" role="main">
    <div class="row">
      <div class="col-sm-12 col-md-6 col-lg-5">
        <div class="container" v-if="action == 'recharge'">
          <div>
            <h1 class="section-title">Payment Successful</h1>
            <p class="text-normal">Congratulations! Your SIM has been recharged.</p>
          </div>
        </div>
        <div class="container" v-if="action == 'sim-order'">
          <div>
            <h1 class="section-title">Payment Successful</h1>
            <p class="text-normal">Congratulations! Your order was Successful.</p>
            <!-- <p class="text-normal">Please login to RICA.</p> -->
            <!-- <vue-login :username="username" redirect="/backend.html" @forgotPasswordChangedEvent="forgotPasswordChanged"></vue-login> -->
          </div>
        </div>
        <div class="container" v-if="action == 'update-credit-card'">
          <div>
            <h1 class="section-title">Payment Successful</h1>
            <p class="text-normal">Congratulations! Your credit card details updated successfully.</p>
            <p class="text-normal">Please login to the manage area below.</p>
            <vue-login :username="username" redirect="/backend.html" @forgotPasswordChangedEvent="forgotPasswordChanged"></vue-login>         
          </div>
        </div>
      </div>
      <div class="col-sm-12 col-md-6 col-lg-7 image-section">
        <img
          class="img-fluid"
          src="/assets/images/backgrounds/me-you-activation-image.jpg"
          alt="Acivation-Input-Image"
        >
      </div>
    </div>
  </main>
</template>

<script>
import VueLogin from "@/components/elements/vue-login.vue";

export default {
  name: "payment-successful",
  components: {
    'vue-login': VueLogin
  },
  data: function() {
    return {
      action: false
    };
  },
  mounted() {
    var self = this;
    self.isForgotPassword = false;
    self.action = self.$route.query.action || null;
  },
  methods: {
    forgotPasswordChanged() {      
      var self = this;
      self.$log.debug("Handle Forgot Password Changed");
      self.isForgotPassword = !self.isForgotPassword;
    },
  }
};
</script>

<style lang="scss" scoped>
</style>